import { ToastType } from "../classes";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const _CHANGE = "CHANGE_TOAST";

// Action Create Function
export const changeToast = (
  isShown?: boolean | null,
  toast_type?: ToastType | null,
  toast_text?: string | null,
  btn_label?: string | null,
  onBtnClick?: (params: any) => void
) =>
  // console.log('changeToast: ', isShown),
  ({
    type: _CHANGE,

    isShown: isShown,

    toast_type: toast_type,
    toast_text: toast_text,
    btn_label: btn_label,
    onBtnClick: onBtnClick,
  });

// initState
const initialState = {
  isShown: false,

  //toast 정보들
  toast_type: ToastType.no_icon,
  toast_text: "",
  btn_label: "",
  onBtnClick: () => {},
};

// Reducer

interface toastInterface {
  isShown: boolean;
  toast_type: ToastType;
  toast_text: string;
  btn_label: string;
  onBtnClick: () => void;
}

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    setToast: (state, action: PayloadAction<toastInterface>) => {
      state.isShown = action.payload.isShown;
      state.toast_type = action.payload.toast_type;
      state.toast_text = action.payload.toast_text;
      state.btn_label = action.payload.btn_label;
      state.onBtnClick = action.payload.onBtnClick;
    },
  },
});
// export default function toastReducer(state = initialState, action: any) {
//   switch (action.type) {
//     case _CHANGE:
//       return Object.assign({}, state, {
//         isShown: action.isShown,
//         toast_type: action.toast_type,
//         toast_text: action.toast_text,
//         btn_label: action.btn_label,
//         onBtnClick: action.onBtnClick,
//       });
//     default:
//       return state;
//   }
// }

export const { setToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
